<style src="../assets/style.css">
</style>
<template>
    <div :class="{'product_list': carousel.carouselitems && carousel.carouselitems.length > 0}">
        <div v-if="carousel.carouselitems && carousel.carouselitems.length > 0">
            <v-carousel>
                <v-carousel-item
                    class="productListCarousel"
                    v-for="(item, index) in carousel.carouselitems"
                    :key="index"
                    :src="item.media_url"
                    reverse-transition="fade"
                    transition="fade"
                >
                <!--                <div class="carousel__content" v-html="item.content"></div>-->
                </v-carousel-item>
            </v-carousel>
        </div>
        <div class="solutions">
            <div class="solutions__banner" v-if="solutions.page_image && solutions.carousel_id == null">
                <img :src="solutions.page_image" alt="" class="solutions__img">
            </div>
            <div class="solution" :class="{'solution--even': index % 2 !== 0 }" v-for="(solution, index) in solutions.article" :key="index">
                <div class="solution__container" :class="{'solution__container--even': index % 2 !== 0 }">
                    <div class="solution__media-container">
                        <video autoplay controls :src="solution.url" class="solution__image solution__video" v-if="solution.type === 'video/mp4' || solution.type === 'video/ogg' || solution.type === 'video/webm'"></video>
                        <img :src="solution.url" alt="" class="solution__image" v-else>
                    </div>
                    <div class="solution__box" :class="{'solution__box--even': index % 2 !== 0 }">
                        <h5 class="solution__name"> {{ solution.title }} </h5>
                        <div class="solution__content" v-html="limitLength(solution.content)"></div>
                        <a href="#" @click.prevent="goTo(solution.slug)" class="btn btn-primary solution__btn">Cere Oferta</a> 
                    </div>
                </div>
            </div>
        </div>
        <app-benefits v-if="benefits.length > 0" :benefits="benefits"></app-benefits>
        <div class="partners" v-if="solutions.partenerList.length > 0 || testimonials.length > 0">
            <h2 class="partners__title">Parteneri & Testimoniale</h2>
            <app-partners v-if="solutions.partenerList.length > 0" :partners="solutions.partenerList"></app-partners>
            <app-testimonials v-if="testimonials.length > 0" :testimonials="testimonials"></app-testimonials>
        </div>
    </div>
</template>

<script>
    import appBenefits from './Shared/Benefits';
    import appPartners from './Shared/Partners';
    import appTestimonials from './Shared/Testimonials';
    import GlobalService from './../services/Global';

    export default {
        data () {
            return {
                solutions: {
                    article: {
                    },
                    partenerList: []
                },
                carousel: {
                    carouselitems: {
                        
                    }  
                },
                display: 0,
                benefits: [],
                testimonials: []
            }
        },
        components: {
            appBenefits,
            appPartners,
            appTestimonials
        },
        created () {
            this.getSolutions()
            window.addEventListener('resize', this.setBtnPosition)
            this.setBtnPosition()
        },
        mounted () {
            this.stopVideo()
        },
        updated () {
            this.stopVideo()
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.setBtnPosition)
        },
        methods: {
            getSolutions () {
                this.$http.get(`/pages/${this.$route.path.replace('/', '')}`)
                .then(response => {
                    this.solutions = response.data
                    this.testimonials = GlobalService.checkForBenefitsOrTestimonials(this.solutions.article, 'testimonials')
                    this.benefits = GlobalService.checkForBenefitsOrTestimonials(this.solutions.article, 'benefits')
                })
                .then(() => {
                    if (this.solutions.carousel_id) {
                        this.getCarousel(this.solutions.carousel_id)
                    }
                    GlobalService.initializeCarousel()
                    GlobalService.initializeSecondCarousel()
                    this.solutions.article = GlobalService.removeBenefitsAndTestimonials(this.solutions.article)
                })
                .catch(e => {
                    console.log(e)
                    this.$router.push('/404')
                })
            },
            goTo (slug) {
                this.$router.push({path: `/article/${slug}`})
            },
            setBtnPosition () {
                if (window.innerWidth > 768) {
                  this.display = 1
                } else {
                  this.display = 0
                }
            },
            getCarousel (id) {
                this.$http.get(`/carousel/${id}`)
                .then(response => {
                    this.carousel = response.data[0]
                })
                .catch(e => {
                    console.log(e)
                })
            },
            limitLength (text) {
                if(text.length > 250) {
                    return text.substring(0,250) + '...'
                } else {
                    return text
                }
            },
            stopVideo() {
                let video = document.querySelectorAll('.solution__video');
                if (video.length > 0) {
                    for(let i = 0; i < video.length; i++) {
                        video[i].pause()
                    }
                }
            }
        }
    }
</script>